import React from 'react';

import Animate from '../Animate';

import Heading from 'components/atoms/Heading';
import Icon from 'components/atoms/Icon';
import Link from 'components/atoms/Link';
import Text from 'components/atoms/Text';
import mapModifiers from 'utils/functions';

interface TitleSectionNewsProps {
  title: string;
  href?: string;
  viewMoreText?: string;
  isViewMoreMobile?: boolean;
  target?: string;
}

const TitleSectionNews: React.FC<TitleSectionNewsProps> = ({
  title,
  href,
  viewMoreText,
  children,
  isViewMoreMobile,
  target,
}) => {
  const RenderHref: React.FC = () => (
    <Link href={href} target={target}>
      <Text modifiers={['700', 'primaryLinear']}>{viewMoreText}</Text>
      <Icon iconName="chervonRight" />
    </Link>
  );
  return (
    <>
      <div className="o-titleSectionNews">
        <Animate type="fadeInUp">
          <div className="o-titleSectionNews_title">
            <Heading type="h5" modifiers={['raisinBlack', 'letterSpacing', '700']} content={title} />
            {children}
          </div>
        </Animate>
        <Animate type="fadeInUp">
          {viewMoreText && (
          <div className={mapModifiers('o-titleSectionNews_viewmore', isViewMoreMobile ? 'hideMb' : '')}>
            <RenderHref />
          </div>
          )}
        </Animate>
      </div>
      {viewMoreText && isViewMoreMobile && (
        <div className={mapModifiers('o-titleSectionNews_viewmore', isViewMoreMobile ? 'showMb' : '')}>
          <RenderHref />
        </div>
      )}
    </>
  );
};

TitleSectionNews.defaultProps = {
  href: '/',
  viewMoreText: '',
  isViewMoreMobile: false,
  target: '_self',
};

export default TitleSectionNews;
